import React from 'react';

const DashboardLoading = () => {
  return (
    <>
      <div className='ml-4 mr-4 lg:mr-4 mt-4 mb-4 overflow-hidden rounded-xl transition-all duration-100 propertyCard'>
        <div className='animate-pulse sm:flex justify-between sm:space-x-4 space-y-4 sm:space-y-0 p-[18px]'>
          <div>
            <div className="flex items-center justify-center h-52 sm:h-[100px] bg-slate-200 rounded-2xl sm:w-[100px] dark:bg-gray-700">
              <svg className="w-12 h-12 text-slate-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                fill="currentColor" viewBox="0 0 640 512">
                <path
                  d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/>
              </svg>
            </div>
          </div>
          <div className='flex justify-start self-center w-full'>
            <div className='w-full space-y-4'>
              <div className="h-2.5 bg-slate-200 rounded-full"></div>
              <div className="h-2.5 bg-slate-200 rounded-full"></div>
            </div>
          </div>
          <div className='flex justify-end sm:justify-start self-center'>
            <div className='w-5 h-5 p-5 rounded-md bg-slate-200'></div>
          </div>
        </div>
      </div>
    </>
  );
};

export { DashboardLoading };
